import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {getStates, searchUsername} from "../common/api/WebApi";
import {displayPhone, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import MDButton from "../../components/MDButton";
import useDebounce from "../common/useDebounce";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";
import {HexColorPicker} from "react-colorful";
import {useAccess} from "../../lib/AccessProvider";

export default function ManageEmployeeModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [employee, setEmployee] = useState(props?.employee);

  const [newEmployee, setNewEmployee] = useState(false);
  const [states, setStates] = useState([]);
  const [formReady, setFormReady] = useState(false);
  const [employeeStartDate, setEmployeeStartDate] = useState(null);
  const [searchIndex, setSearchIndex] = useState(1);
  const [usernameRequest, setUsernameRequest] = useState();
  const [usernameResponse, setUsernameResponse] = useState();
  const [usernameValid, setUsernameValid] = useState(false);
  const [passwd, setPasswd] = useState(null);
  const [passwdConfirm, setPasswdConfirm] = useState(null);
  const [passMatch, setPassMatch] = useState(true);
  const [passValid, setPassValid] = useState(true);
  const [companyAdmin, setCompanyAdmin] = useState(false);
  const [orgOwner, setOrgOwner] = useState(false);
  const [orgAccess, setOrgAccess] = useState(false);

  const {getAccess} = useAccess();

  const toggleCompanyAdmin = (e) => {
    setCompanyAdmin(e.target.checked);
  }

  const toggleOrgOwner = (e) => {
    setOrgOwner(e.target.checked);
  }

  useEffect(()=> {
    let access = getAccess();
    if (access?.ready) {
      setOrgAccess(access);
    }
  },[]);

  useEffect(() => {
    setPasswd(null);
    setPasswdConfirm(null);
    setPassMatch(true);
    setPassValid(true);
  }, [props]);

  useEffect(() => {
    setPassMatch(passwd === passwdConfirm);
    setPassValid((passwd?.length === 0 && passwdConfirm?.length === 0) || passwd === passwdConfirm);
  }, [passwd, passwdConfirm])

  useEffect(() => {
    setUsernameValid(false);
    setUsernameRequest(null);
  }, []);

  useEffect(() => {
    setEmployee(props?.employee);
    setCompanyAdmin(props?.employee?.companyAdmin || false);
    setOrgOwner(props?.employee?.orgOwner || false);
    setUsernameValid(!props?.employee?.newEmployee);
    setNewEmployee(props?.employee?.newEmployee);
  }, [props?.employee]);

  const {
    register,
    handleSubmit,
    setValue, control, reset
  } = useForm({
    values: handleDefaultValues(employee)
  });

  const searchUsernameFn = async (searchCriteria) => {

    let idx = searchIndex + 1;
    setSearchIndex(idx);

    let _search = {...usernameRequest};
    _search.username = searchCriteria;

    let result = await searchUsername(_search, idx);

    setUsernameResponse(result?.resp);
  };

  useEffect(() => {
    if (usernameResponse) {
      setUsernameValid(usernameResponse?.valid);
      setUsernameRequest(usernameResponse?.username);
    }
  }, [usernameResponse]);

  const debounceChanges = useDebounce(function (newChanges) {
    let result = searchUsernameFn(newChanges);
  }, 500, []); // every .5 seconds max

  // use this for reference when editing a modal using form reset() 12/08/2023 - JP
  useEffect(() => {
    reset();
    if (props?.employee) {
      setEmployee(props?.employee);
      if (props?.employee?.employeeStartDate) {
        setEmployeeStartDate(new Date(props?.employee?.employeeStartDate));
      } else {
        setEmployeeStartDate(null);
      }
    }
  }, [props?.employee]);

  useEffect(() => {
    getStates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setStates(result);
        setFormReady(true);
      }
    });
  }, []);

  const handleClose = () => {
    props.handleClose();
  };
  const [expandBackgroundColor, setExpandBackgroundColor] = useState(false);
  const [expandFontColor, setExpandFontColor] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState(props?.employee?.backgroundColor || "#0d6efd");
  const [fontColor, setFontColor] = useState(props?.employee?.fontColor || "#fff");

  const handleSaveEmployee = (data) => {
    let _e = {...data};
    _e.fontColor = fontColor;
    _e.backgroundColor = backgroundColor;
    _e.employeeStartDate = employee.employeeStartDate;
    _e.newEmployee = employee.newEmployee;
    _e.companyAdmin = companyAdmin;
    _e.orgOwner = orgOwner;
    props.handleSaveEmployee(_e);
  };


  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSaveEmployee)} id={'employeeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{newEmployee ? 'Create New' : 'Manage'} Employee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row className={'my-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        {...register('firstName')}
                        autoComplete="off" required
                        className="form-control" id="firstName"
                        InputLabelProps={{shrink: true}}
                        placeholder="Enter First name"
                        label="First name"
                      />

                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        {...register('lastName')}
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="lastName"
                        placeholder="Enter Last name"
                        label="Last name"
                      />

                    </div>
                  </Col>
                </Row>
                <Row className={'my-4'}>
                  <Col className={'col'} md={6} sm={12} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="email"
                        {...register('email')}
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="email"
                        placeholder="Enter Email"
                        label="Email"
                      />

                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('primaryPhone', {
                          onChange: (e) => {
                            e.target.value = displayPhone(e.target.value);
                          }
                        })}
                        className="form-control" id="primaryPhone"
                        label="Phone"
                        placeholder="Enter Phone"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className={'my-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('address1')}
                        autoComplete="off"
                        className="form-control" id="address1"
                        label="Address"
                        placeholder="Enter Address"
                      />
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('address2')}
                        className="form-control" id="address2"
                        label="Address 2"
                        placeholder="Enter Address 2"
                      />
                    </div>
                  </Col>
                </Row>

                <Row className={'my-4'}>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('city')}
                        className="form-control" id="city"
                        label="City"
                        placeholder="Enter City"/>
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label className="native-label" htmlFor="state">State</label>
                      {states?.length && <NativeSelect
                        variant="outlined"
                        id={'state'} name={'state'} className={'form-control'}
                        {...register('state.stateId')}
                        defaultValue={states[0].stateId}>
                        {
                          states.map((c) =>
                            <option value={c.stateId} key={c.stateId}>
                              {c.stateName}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('zipCode')}
                        className="form-control" id="zipCode"
                        label="Zip"
                        placeholder="Enter Zip"/>
                    </div>
                  </Col>
                </Row>
                <Row className={'my-4'}>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('username')}
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        disabled={!newEmployee}
                        className="form-control" id="username"
                        placeholder="Enter Username"
                        label="Username" onChange={(e) => {
                        debounceChanges(e.target.value)
                      }}/>
                      {!usernameValid && <span className={'text-danger'}>
                        {usernameRequest?.length && <span>Username in use</span>}
                        {!usernameRequest?.length && <span>Username required</span>}
                      </span>
                      }
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="password"
                        {...register('passwd', {
                          onChange: (e) => {
                            setPasswd(e.target.value)
                          }
                        })}
                        InputLabelProps={{shrink: true}}
                        autoComplete="off"
                        className="form-control" id="passwd"
                        placeholder={newEmployee ? 'Enter Password' : 'Enter New Password'}
                        label={newEmployee ? 'Enter Password' : 'Enter New Password'}/>
                    </div>
                    {(passwd?.length > 0 || passwdConfirm?.length > 0) && !passMatch &&
                      <span className={'text-danger'}>Password does not match</span>
                    }
                  </Col>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="password"
                        {...register('passwdConfirm', {
                          onChange: (e) => {
                            setPasswdConfirm(e.target.value)
                          }
                        })}
                        InputLabelProps={{shrink: true}}
                        autoComplete="off"
                        className="form-control" id="passwdConfirm"
                        placeholder={newEmployee ? 'Confirm Password' : 'Confirm New Password'}
                        label={newEmployee ? 'Confirm Password' : 'Confirm New Password'}/>
                    </div>
                  </Col>

                </Row>


                <Row className={'my-4'}>
                  {(context.sessionUser?.superAdmin || context.sessionUser?.companyAdmin) &&
                    <Col className={'col'} sm={4} xs={12}>
                      <div className="native-margin-fix">
                        <label className="native-label"
                               htmlFor="startDate">Employee Start Date</label>
                        <DesktopDatePicker
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          name="startDate"
                          label="Employee Start Date"
                          value={employee?.employeeStartDate ? dayjs(employee?.employeeStartDate) : null}
                          onChange={(e) => {
                            setEmployeeStartDate(e?.$d || null);
                            let _emp = {...employee}
                            _emp.employeeStartDate = e?.$d;
                            setEmployee(_emp);
                          }}
                        />
                      </div>
                    </Col>
                  }

                  {(context.sessionUser?.superAdmin || context.sessionUser?.companyAdmin) &&
                    <Col className={'col'} sm={4} xs={12}>
                      <label
                        htmlFor="companyAdmin">
                        Company Admin
                        <Switch
                          name={'companyAdmin'}
                          id={'companyAdmin'}
                          checked={companyAdmin}
                          style={{marginRight: '5px'}}
                          onChange={toggleCompanyAdmin}
                        /> </label>
                    </Col>}
                  {orgAccess && (context.sessionUser?.superAdmin || context.sessionUser?.companyAdmin) &&
                    <Col className={'col'} sm={4} xs={12}>
                      <label
                        htmlFor="companyAdmin">
                        Org Owner
                        <Switch
                          name={'orgOwner'}
                          id={'orgOwner'}
                          checked={orgOwner}
                          style={{marginRight: '5px'}}
                          onChange={toggleOrgOwner}
                        /> </label>
                    </Col>}

                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <h5>Display Options</h5>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Calendar Background Color</label>
                      <MDInput type="text" required
                               InputProps={{
                                 startAdornment: <>
                                   <div
                                     onClick={() => {
                                       setExpandBackgroundColor(!expandBackgroundColor)
                                     }}
                                     style={{
                                       margin: '-5px',
                                       borderRadius: '4px',
                                       boxShadow: '0 0 2px #ccc',
                                       cursor: 'pointer',
                                       width: '35px',
                                       height: '25px',
                                       background: backgroundColor
                                     }}></div>
                                 </>
                               }}
                               {...register('backgroundColor')}
                               onChange={(e) => {
                                 setBackgroundColor(e.target.value)
                               }}
                               value={backgroundColor}/>
                      {expandBackgroundColor &&
                        <div style={{
                          paddingRight: '20px',
                          marginRight: '-20px'
                        }}>
                          <MDButton
                            style={{
                              float: 'right',
                              margin: '-10px',
                              zIndex: '3',
                              position: 'relative',
                              background: '#fff'
                            }}
                            onClick={() => {
                              setExpandBackgroundColor(false)
                            }}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                          >
                            <Icon>close</Icon>
                          </MDButton>

                          <HexColorPicker
                            style={{
                              width: 'auto'
                            }}
                            color={backgroundColor} onChange={(color) => {
                            setBackgroundColor(color);
                          }}/>
                        </div>
                      }
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryWaiver">Calendar Font Color</label>
                      <MDInput type="text" required
                               InputProps={{
                                 startAdornment: <>
                                   <div
                                     onClick={() => {
                                       setExpandFontColor(!expandFontColor)
                                     }}
                                     style={{
                                       margin: '-5px',
                                       borderRadius: '4px',
                                       boxShadow: '0 0 2px #ccc',
                                       cursor: 'pointer',
                                       width: '35px',
                                       height: '25px',
                                       background: fontColor
                                     }}></div>
                                 </>
                               }}
                               {...register('fontColor')}
                               onChange={(e) => {
                                 setFontColor(e.target.value)
                               }}
                               value={fontColor}/>
                      {expandFontColor &&
                        <div style={{
                          paddingRight: '20px',
                          marginRight: '-20px'
                        }}>
                          <MDButton
                            style={{
                              float: 'right',
                              margin: '-10px',
                              zIndex: '3',
                              position: 'relative',
                              background: '#fff'
                            }}
                            onClick={() => {
                              setExpandFontColor(false)
                            }}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            circular
                            iconOnly
                          >
                            <Icon>close</Icon>
                          </MDButton>

                          <HexColorPicker
                            style={{
                              width: 'auto'
                            }}
                            color={fontColor} onChange={(color) => {
                            setFontColor(color);
                          }}/>
                        </div>
                      }
                    </div>
                  </Col>
                  <Col className={'col'} sm={4} xs={12}>
                    <label>Example</label>
                    <div style={{
                      borderRadius: '12px',
                      padding: '10px 20px 10px 25px',
                      background: backgroundColor
                    }}>
                      <p style={{
                        color: fontColor
                      }}>This is Example Text</p>

                    </div>
                  </Col>

                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={props.saving || !usernameValid || !passValid}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}